import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { Form, Button, Card, Alert, Spinner } from "react-bootstrap";

const COMPANY_DATA = {
  name: "TORI Viktoriya Manachynska",
  address: "50-202 Wrocław, ul. Księcia Witolda 49/15",
  nip: "NIP: 7822599564",
};

const DriverUploadInvoicePage = () => {
  const { t } = useTranslation();
  const [grossAmount, setGrossAmount] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [errors, setErrors] = useState({ grossAmount: "", file: "" });

  const handleGrossChange = (e) => {
    setGrossAmount(e.target.value);
    if (errors.grossAmount) setErrors((prev) => ({ ...prev, grossAmount: "" }));
    setError("");
  };

  const handleFileChange = (e) => {
    const f = e.target.files?.[0] || null;
    setFile(f);
    if (errors.file) setErrors((prev) => ({ ...prev, file: "" }));
    setError("");
  };

  const validate = () => {
    const gross = parseFloat(String(grossAmount).replace(",", "."));
    const err = {
      grossAmount:
        grossAmount.trim() === ""
          ? t("driverInvoiceGrossRequired")
          : Number.isNaN(gross) || gross < 0
            ? t("driverInvoiceGrossInvalid")
            : "",
      file: !file ? t("driverInvoiceFileRequired") : "",
    };
    setErrors(err);
    return !err.grossAmount && !err.file;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");
    if (!validate()) return;

    const gross = parseFloat(String(grossAmount).replace(",", "."));

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("gross_amount", gross);
      formData.append("image", file);
      const token = localStorage.getItem("token");
      const res = await axios.post("/api/driver-invoices/my/upload", formData, {
        headers: {
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
          "Content-Type": "multipart/form-data",
        },
      });
      if (res.data?.success) {
        setSuccess(t("driverInvoiceSuccess"));
        setGrossAmount("");
        setFile(null);
        const input = document.getElementById("driver-invoice-file");
        if (input) input.value = "";
      } else {
        setError(res.data?.error || t("driverInvoiceErrorUpload"));
      }
    } catch (err) {
      setError(err.response?.data?.error || err.message || t("driverInvoiceErrorGeneric"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h2 className="mb-4">{t("driverInvoiceUploadTitle")}</h2>

      <Card className="mb-4 border-primary bg-light">
        <Card.Body className="py-3">
          <Card.Title as="h6" className="text-primary mb-2">{t("driverInvoiceUploadDataTitle")}</Card.Title>
          <div className="fw-bold">{COMPANY_DATA.name}</div>
          <div>{COMPANY_DATA.address}</div>
          <div className="fw-bold">{COMPANY_DATA.nip}</div>
        </Card.Body>
      </Card>

      <Card>
        <Card.Body>
          {error && <Alert variant="danger" dismissible onClose={() => setError("")}>{error}</Alert>}
          {success && <Alert variant="success" dismissible onClose={() => setSuccess("")}>{success}</Alert>}

          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>{t("driverInvoiceGrossLabel")} <span className="text-danger">*</span></Form.Label>
              <Form.Control
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"
                value={grossAmount}
                onChange={handleGrossChange}
                className={errors.grossAmount ? "border-danger" : ""}
                isInvalid={!!errors.grossAmount}
              />
              <Form.Control.Feedback type="invalid">{errors.grossAmount}</Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{t("driverInvoiceFileLabel")} <span className="text-danger">*</span></Form.Label>
              <Form.Control
                id="driver-invoice-file"
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                className={errors.file ? "border-danger" : ""}
              />
              {errors.file && <Form.Text className="text-danger d-block mt-1">{errors.file}</Form.Text>}
              <Form.Text className="text-muted d-block">
                {t("driverInvoiceFileHint")}
              </Form.Text>
              {file && <div className="small mt-1">{t("driverInvoiceFileSelected")} {file.name}</div>}
            </Form.Group>

            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? <Spinner animation="border" size="sm" className="me-2" /> : null}
              {t("driverInvoiceSubmitBtn")}
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
};

export default DriverUploadInvoicePage;
